module.exports = __webpack_public_path__ + "static/media/Versandbereit.ca87ef20.svg";